export const mapCaseType = (key) => {
  const map = {
    SPEEDING: "Ordnungswidrigkeit - Geschwindigkeit",
    RED_LIGHT: "Ordnungswidrigkeit - Rotlicht",
    DISTANCE: "Ordnungswidrigkeit - Abstand",
    MOBILE_PHONE: "Ordnungswidrigkeit - Handy",
    ALCOHOL_DRUGS: "Ordnungswidrigkeit - Berauschende Mittel",
    PARKING: "Ordnungswidrigkeit - Falsch geparkt",
    ACCIDENT: "Ordnungswidrigkeit - Unfall",
  };

  return key ? map[key] : "";
};

export const mapLetterType = (key) => {
  const map = {
    HEARING_FORM: "Anhörungsbogen",
    FINE_NOTICE: "Bußgeldbescheid",
    WITNESS_QUESTIONNAIRE: "Zeugenfragebogen",
    NONE: "Bisher noch nichts",
    UNSURE: "Nicht sicher",
  };

  return key ? map[key] : "";
};

export const mapLegalInsurance = (hasLegalInsurance) => {
  return hasLegalInsurance ? "Ja" : "Nein";
};
